export default __webpack_public_path__ + "static/media/SERIES-8000-8100MPNH-BLANK-ENCLOSURE-CLOSE-UP-.ec7f9e17.jpeg";